import styled from 'src/styles/theme';
import { rem } from 'polished';
import { ModalNeedHelpStyled } from '../ModalNeedHelpStyled';

export const ModalNeedHelpStyledAC = styled(ModalNeedHelpStyled)`
    .description {
    }

    .phone,
    .request,
    .testDrive,
    .faq {
        .link {
            a,
            button {
                color: ${({ theme }) => theme.colors.red};
            }

            svg {
                path {
                    fill: ${({ theme }) => theme.colors.red};
                }
            }

            &:hover,
            &:focus-visible {
                a,
                button {
                    color: ${({ theme }) => theme.colors.grey5};
                }

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.grey5};
                    }
                }
            }
        }
    }
`;
